/**
 * Loads Cloudflare Turnstile's `api.js` exactly once per page. Every `TurnstileWidget` shares the
 * one promise, so ten mounts (or React StrictMode's double-run) inject one script tag.
 */
export const TURNSTILE_SCRIPT_URL = "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit";
let pending = null;
export function loadTurnstile() {
    if (pending !== null)
        return pending;
    pending = new Promise((resolve, reject) => {
        const fail = () => {
            // Drop the cached rejection so a later mount can retry.
            pending = null;
            reject(new Error("Turnstile failed to load"));
        };
        if (window.turnstile !== undefined) {
            resolve(window.turnstile);
            return;
        }
        const script = document.createElement("script");
        script.src = TURNSTILE_SCRIPT_URL;
        script.async = true;
        script.defer = true;
        script.dataset["turnstileLoader"] = "true";
        script.onload = () => {
            if (window.turnstile === undefined)
                fail();
            else
                resolve(window.turnstile);
        };
        script.onerror = () => {
            script.remove();
            fail();
        };
        document.head.appendChild(script);
    });
    return pending;
}
/** Test seam: forget the cached promise. */
export function resetTurnstileLoaderForTests() {
    pending = null;
}
//# sourceMappingURL=turnstile-loader.js.map